import React from 'react';
import {
    EncForm,
    EncInputField,
    EncRadioField,
    EncSelectField,
    withEncFormHandler
} from '../../../../../components/hocs/form-validation/index';

const currencyOptions = [
    {key: 'GBP', text: 'GBP', value: 'GBP'},
    {key: 'AUD', text: 'AUD', value: 'AUD'},
    {key: 'USD', text: 'USD', value: 'USD'},
    {key: 'EUR', text: 'EUR', value: 'EUR'},
    {key: 'SGD', text: 'SGD', value: 'SGD'}
];

const AddDataProduct = props => {

    const {formProperties, fieldProperties, existingDataProducts} = props;
    const existingProductCodes = existingDataProducts.map(dataProduct => dataProduct.chargeCode);

    return (
        <EncForm formProperties={formProperties} fieldProperties={fieldProperties}>
            <EncInputField
                id="productName"
                label="productBundles:product.bundle.product.name"
                validator={{
                    type: 'string',
                    rules: ['required']
                }}
            />
            <EncInputField
                id="productCode"
                label="productBundles:product.bundle.product.code"
                validator={{
                    type: 'string',
                    rules: ['required', 'uniqueProductCode'],
                    existingProductCodes
                }}
            />
            <EncInputField
                id="productPrice"
                label="productBundles:product.bundle.product.price"
                type="number"
                validator={{
                    type: 'number',
                    rules: ['required']
                }}
            />
            <EncSelectField
                id="currency"
                label="productBundles:product.bundle.currency"
                options={currencyOptions}
                validator={{
                    type: 'string',
                    rules: ['required']
                }}
            />
            <div className="radio__group">
                <EncRadioField
                    id="taxCategory"
                    label="productBundles:product.bundle.none"
                    value={'NONE'}
                />
                <EncRadioField
                    id="taxCategory"
                    label="productBundles:product.bundle.taxable"
                    value={'TAXABLE'}
                />
                <EncRadioField
                    id="taxCategory"
                    label="productBundles:product.bundle.non.taxable"
                    value={'NON_TAXABLE'}
                />
            </div>
        </EncForm>
    );
};

const FORM_VALIDATION_OPTIONS = {
    header: 'productBundles:product.bundle.add.data.product',
    successMessage: 'productBundles:product.bundle.data.product.added',
    validateOnChange: false,
    validateOnBlur: true
};

export default withEncFormHandler(
    FORM_VALIDATION_OPTIONS
)(AddDataProduct);


